module.exports = __webpack_public_path__ + "1fad8e136ef704d1bf57e1cc887d824b.svg";